module.exports = __webpack_public_path__ + "media/images/icons/robot-3fd5de66cceadc5f104bb2e98aff1d23.svg";